import { useQueries } from '@tanstack/react-query';
import { candidateVerificationService } from '../services/candidate-verification.service';
import { useCandidateSession } from '../context/CandidateSessionContext';
import { collectContactResults } from '../utils/contact-results';
import type { ContactsByExperience } from '../utils/contact-results';
import type { ContactCounts } from '../utils/wizard-progress';

interface CandidateContactsResult {
  contactCounts: ContactCounts;
  contactsByExperience: ContactsByExperience;
  loadingExperienceIds: string[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export function useCandidateContacts(experienceIds: string[]): CandidateContactsResult {
  const { isAnonymous, shareId } = useCandidateSession();

  const results = useQueries({
    queries: experienceIds.map((experienceId) => ({
      queryKey: isAnonymous
        ? ['candidate-verifications', 'anonymous', shareId, experienceId]
        : ['candidate-verifications', experienceId],
      queryFn: () =>
        isAnonymous
          ? candidateVerificationService.listByShareId(shareId!, experienceId)
          : candidateVerificationService.list(experienceId),
    })),
  });

  return {
    ...collectContactResults(experienceIds, results),
    isLoading: results.some((result) => result.isLoading),
    isError: results.some((result) => result.isError),
    refetch: (): void => results.forEach((result) => void result.refetch()),
  };
}
